import { HttpClient } from '../../protocols/http/httpClient'
import {
  IUpdateCustomRole,
  CreateRoleParams,
  CustomRole
} from '../../../domain/usecases/Roles'
import { throwIfHttpError } from '../../../validation/httpError'

export class RemoteUpdateCustomRole implements IUpdateCustomRole {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async update(
    roleId: string,
    params: Partial<CreateRoleParams>
  ): Promise<CustomRole> {
    const httpResponse = await this.httpClient.patch?.({
      url: `${this.url}/roles/custom/${roleId}`,
      data: params
    })

    return throwIfHttpError(httpResponse, 'Erro ao atualizar função')
  }
}
